@if (vkforgs$ | async; as vkforgs) {
  <div
    (click)="(vkforgs?.length || 0) > 1 && onChangeAccount(vkforgs)"
    class="flex flex-row items-center gap-0.5"
  >
    @if (vkforg$ | async; as selectedVkforg) {
      @if ((vkforgs?.length || 0) > 1) {
        <div class="text-sm font-semibold">
          {{ selectedVkforg?.kurzbezeichnung || selectedVkforg?.vkforg }}
        </div>
      } @else if ((vkforgs?.length || 0) <= 1) {
        <span class="text-sm font-semibold">{{
          selectedVkforg?.kurzbezeichnung ||
            selectedVkforg?.vkforg ||
            vkforgs[0]?.kurzbezeichnung
        }}</span>
      }
    }

    @if ((vkforgs?.length || 0) > 1) {
      <div class="rounded-lg h-full flex items-center justify-center">
        <soft-icon name="fa-solid fa-caret-down" class="text-xs opacity-90"></soft-icon>
      </div>
    }
  </div>
}

@if (patchContextService.pending$ | async) {
  <soft-blocking-loading-spinner></soft-blocking-loading-spinner>
}
